import { FC } from "react";
import { useNavigate } from "react-router-dom";

import homecook_logo from "../../assets/img/homecook_logo.png";

import { ReactComponent as MobileNavMenuIcon } from "../../icons/MobileNavMenuIcon.svg";
import { ReactComponent as CancelIcon } from "../../icons/CancelIcon.svg";

type NavbarMobileProps = {
  isMobileNavbarMenuOpen: boolean;
  setIsMobileNavbarMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const NavbarMobile: FC<NavbarMobileProps> = ({
  setIsMobileNavbarMenuOpen,
  isMobileNavbarMenuOpen,
}) => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate("/");
  };

  function handleMenuButtonClick() {
    setIsMobileNavbarMenuOpen((prev) => !prev);
  }

  return (
    <nav className="border-b border-[#E9E9E9] bg-text-1000 h-[90px] px-[20px] fixed top-0 left-0 right-0 z-[100]">
      <div className="flex h-full w-full items-center justify-between">
        {/* HomeCook Logo */}
        <div
          className="flex items-center gap-[8px] cursor-pointer"
          onClick={goToHome}
        >
          <img
            src={homecook_logo}
            alt="Homecook Logo"
            className="w-[32px] h-[32px]"
          />
          <h4 className="text-[24px] font-bold text-primaryDark-0 font-raleway">
            HomeCook
          </h4>
        </div>

        {/* Menu Button */}
        <div>
          <button
            className="flex items-center gap-[8px] text-primayDark-0 text-[14px] font-raleway font-bold border border-[#E9E9E9] rounded-[40px] px-[16px] py-[12px]"
            onClick={handleMenuButtonClick}
            type="button"
          >
            {isMobileNavbarMenuOpen ? (
              <>
                <CancelIcon className="w-[20px] h-[20px]" /> Close
              </>
            ) : (
              <>
                <MobileNavMenuIcon className="w-[20px] h-[20px]" /> Menu
              </>
            )}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default NavbarMobile;
